import { Component, input, output, signal } from '@angular/core';
import { delay } from '@gametailors/web-core/misc';
import { AudioEffectPlayer } from '../../utils/audio.utils';
import { RidButton } from '../rid-button/rid-button';
import { RidRatingStar } from '../rid-rating-star/rid-rating-star';

@Component({
  selector: 'rid-rating-modal',
  imports: [RidRatingStar, RidButton],
  templateUrl: './rid-rating-modal.html',
  host: {
    class: 'absolute',
    'animate.enter': 'anim-pop-in',
    'animate.leave': 'anim-pop-out',
  },
})
export class RidRatingModal {
  title = input<string>('Nauwkeurigheid');
  starsOnly = input<boolean>(false);

  protected readonly starLabels = ['enkele goed', 'gedeelte goed', 'merendeel goed', 'bijna alles goed', 'alles goed'];

  rating = signal<number | undefined>(undefined);
  litCount = signal(0);

  canceled = output<void>();
  continued = output<number>();

  rate(rating: number) {
    this.rating.set(rating);
    this.litCount.set(0);
    AudioEffectPlayer.playStarRating(rating + 1, (i) => this.litCount.set(i + 1));

    if (this.starsOnly()) {
      delay(500 + rating * 100).then(() => this.next());
    }
  }

  next() {
    const rating = this.rating();
    if (rating === undefined) return;

    this.continued.emit(rating);
  }

  cancel() {
    this.canceled.emit();
  }
}
